<template>
  <div class="checkbox">
    <input type="checkbox" v-model="model" :required="required" />
    <div class="v"></div>
    <div v-if="label || $slots.default" class="checkbox__label">
      <slot>
        <span>{{ label }}</span>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  model: {
    event: 'change',
    prop: 'value',
  },
  props: {
    value: Boolean,
    label: String,
    round: Boolean,
    required: {
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('set', v)
        this.$emit('change', v)
      },
    },
  },
}
</script>

<style lang="scss">
.checkbox {
  display: flex;
  position: relative;
  overflow: hidden;
  height: 15px !important;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 3px;

  input {
    @include inputHide;
  }

  .v {
    width: 15px !important;
    height: 15px !important;
    border: 1px solid #d0d0d0;
    box-sizing: border-box;
    border-radius: 5px;
    transition: all 0.25s;
    background: transparent no-repeat center center;
  }

  input:checked + .v {
    background-color: $primary;
    background-image: url('~@/assets/icons/checkbox-w.svg');
    border: none;
  }
}
</style>
